// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__8W0hu","menu":"Navbar_menu__6-kXU","mobile_btn":"Navbar_mobile_btn__E4WzF","active":"Navbar_active__bixvb"};